import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductStart, setProduct } from './../../redux/Products/products.actions';
import { addProduct } from './../../redux/Cart/cart.actions';
import Button from './../forms/Button';
import { motion } from 'framer-motion';
import './styles.scss';

const mapState = state => ({
  product: state.productsData.product
});

const ProductCard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { productID } = useParams();
  const { product } = useSelector(mapState);
  const [loading, setLoading] = useState(true);

  const {
    productThumbnail,
    productName,
    productPrice,
    productDesc,
  } = product || {};

  useEffect(() => {
    dispatch(fetchProductStart(productID));
    setLoading(true);

    return () => dispatch(setProduct({}));
  }, [productID]);

  useEffect(() => {
    if (product && Object.keys(product).length > 0) {
      setLoading(false);
    }
  }, [product]);

  const handleAddToCart = () => {
    if (!product) return;
    dispatch(addProduct(product));
    history.push('/cart');
  };

  if (loading) {
    return (
      <div className="productCard loading">
        <p>Loading product...</p>
      </div>
    );
  }

  if (!productName) {
    return (
      <div className="productCard error">
        <p>Product not found.</p>
      </div>
    );
  }

  return (
    <motion.div
      className="productCardRow"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="imageSection">
        <img
          src={productThumbnail || 'https://via.placeholder.com/500x500?text=No+Image'}
          alt={productName}
        />
      </div>

      <div className="detailsSection">
        <h1>{productName}</h1>
        <p className="price">${productPrice}</p>
        <div
          className="desc"
          dangerouslySetInnerHTML={{ __html: productDesc || '<p>No description available.</p>' }}
        />
        <Button type="button" onClick={handleAddToCart}>
          Add to Cart
        </Button>
      </div>
    </motion.div>
  );
};

export default ProductCard;
